import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCkXQA3hHHxIncHkbAg_ia_wXi-9_UgWo0",
  authDomain: "cashtap-948a9.firebaseapp.com",
  projectId: "cashtap-948a9",
  storageBucket: "cashtap-948a9.firebasestorage.app",
  messagingSenderId: "1063840981045",
  appId: "1:1063840981045:web:8846dd31d521710284517c",
};

const app = initializeApp(firebaseConfig);

// Firestore instance
export const db = getFirestore(app);
